import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { reorder } from "../actions/content";
import { push } from "../history";
import utils from "../lib/utils";
import Content from "../components/Content";
import SortContainer from "../components/SortContainer";
import Pagination from "../components/Pagination";
import ContentUtils from "../lib/ContentUtils";

@connect(null)
export default class List extends Component {
  static propTypes = {
    items: PropTypes.array
  };

  static contextTypes = {
    type: PropTypes.object
  };

  state = {
    filter: "",
    currentPage: 0
  };

  filter = content => {
    const filterValue = this.state.filter.toLowerCase();

    for (const key in content) {
      const value = (content[key] || "").toString().toLowerCase();
      if (value.indexOf(filterValue) > -1) return true;
    }

    return false;
  };

  onFilter = e => {
    const filter = e.target.value;
    this.setState({ filter });
  };

  didSort = async content => {
    const { dispatch } = this.props;
    const { type } = this.context;
    content.forEach((item, i) => {
      item.position = i;
    });

    const payload = content.map(item => ({ id: item.id }));

    await dispatch(reorder(payload, type.id));
  };

  gotoPage = currentPage => {
    this.setState({ currentPage });
  };

  renderItem = item => {
    return (
      <Content
        key={item.id}
        content={item}
        onClick={e => {
          push(utils.contentUrl(item.id));
        }}
      />
    );
  };

  render() {
    let { items } = this.props;
    const { type } = this.context;
    const { filter } = this.state;

    // sorting
    items = ContentUtils.sort(items, type);

    // filtering
    if (filter && filter.length) {
      items = items.filter(this.filter);
    }

    // pagination
    let numPages = 1;
    let { currentPage } = this.state;
    const itemsPerPage = 50;

    if (itemsPerPage > 0 && items.length) {
      numPages = Math.ceil(items.length / itemsPerPage);
      if (currentPage > numPages - 1) {
        currentPage = numPages - 1;
      }
      items = items.slice(
        currentPage * itemsPerPage,
        (currentPage + 1) * itemsPerPage
      );
    }

    const pageOptions = Array.apply(null, Array(numPages)).map((v, i) => {
      return (
        <option key={i} value={i}>
          {i + 1}
        </option>
      );
    });

    return (
      <div className="content-list layout-default">
        <div className="content-search">
          <input
            type="search"
            placeholder="Search for content..."
            value={filter}
            onKeyUp={this.onFilter}
            onChange={this.onFilter}
          />
        </div>
        <div className="content-table">
          <div className="content-header" />
          <SortContainer
            id={type.id}
            itemType="CONTENT"
            items={items}
            didSort={this.didSort}
            renderItem={this.renderItem}
            className="content-table-body"
          />
        </div>
        {numPages > 1 && (
          <Pagination
            onChange={this.gotoPage}
            currentPage={currentPage}
            numPages={numPages}
          />
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/containers/LayoutList.js